import React from "react";

import { Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const TwoColumnContainer = ({ containerAlignItems = "baseline", gridDistance, labelStyle, label, required, children }) => {
    const theme = useTheme();
    return (
        <Grid container spacing={2} alignItems={containerAlignItems}>
            <Grid item xs={gridDistance ? gridDistance[0] : 4}>
                <Typography
                    sx={labelStyle ? { ...labelStyle } : {
                        fontSize: theme.typography.customFontSize[2],
                        color: theme.palette.primary.black,
                        fontWeight: theme.typography.customFontWeight[0],
                    }}>
                    {label}
                    {required && (
                        <Typography component="span" sx={{ color: theme.palette.primary.redPrimary }}>
                            *
                        </Typography>
                    )}
                </Typography>
            </Grid>
            <Grid item xs={gridDistance ? gridDistance[1] : 8}>
                {children}
            </Grid>
        </Grid>
    );
}

export default TwoColumnContainer;
